import React, { useState } from 'react';
import { theme } from '../styles/theme';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { Select } from '../components/Select';

export const NotificationSettingsPage = () => {
  // Email Notifications
  const [emailQueryResponse, setEmailQueryResponse] = useState('instant');
  const [emailBetaApplication, setEmailBetaApplication] = useState('instant');
  const [emailManuscriptRequest, setEmailManuscriptRequest] = useState('instant');
  const [emailFeedback, setEmailFeedback] = useState('instant');
  const [emailMessages, setEmailMessages] = useState('instant');
  const [emailSystem, setEmailSystem] = useState('daily');

  // In-App Notifications
  const [inAppQueryResponse, setInAppQueryResponse] = useState(true);
  const [inAppBetaApplication, setInAppBetaApplication] = useState(true);
  const [inAppManuscriptRequest, setInAppManuscriptRequest] = useState(true);
  const [inAppFeedback, setInAppFeedback] = useState(true);
  const [inAppMessages, setInAppMessages] = useState(true);
  const [inAppSystem, setInAppSystem] = useState(true);

  // Digest Settings
  const [enableDigest, setEnableDigest] = useState('yes');
  const [digestFrequency, setDigestFrequency] = useState('daily');
  const [digestTime, setDigestTime] = useState('08:00');

  // General Settings
  const [soundEnabled, setSoundEnabled] = useState('yes');
  const [desktopNotifications, setDesktopNotifications] = useState('yes');
  const [notificationBadge, setNotificationBadge] = useState('yes');

  const handleSave = () => {
    console.log('Saving notification settings:', {
      email: {
        queryResponse: emailQueryResponse,
        betaApplication: emailBetaApplication,
        manuscriptRequest: emailManuscriptRequest,
        feedback: emailFeedback,
        messages: emailMessages,
        system: emailSystem,
      },
      inApp: {
        queryResponse: inAppQueryResponse,
        betaApplication: inAppBetaApplication,
        manuscriptRequest: inAppManuscriptRequest,
        feedback: inAppFeedback,
        messages: inAppMessages,
        system: inAppSystem,
      },
      digest: {
        enabled: enableDigest,
        frequency: digestFrequency,
        time: digestTime,
      },
      general: {
        soundEnabled,
        desktopNotifications,
        notificationBadge,
      },
    });
    window.alert('Notification settings saved successfully!');
  };

  const handleTestNotification = () => {
    window.alert('Test notification sent! Check your notification center.');
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: theme.colors.background,
      fontFamily: theme.fonts.primary,
    }}>
      <Header />

      <main style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '60px 40px',
      }}>
        {/* Header */}
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{
            fontSize: '40px',
            fontWeight: '400',
            marginBottom: '8px',
            color: theme.colors.textPrimary,
          }}>
            Notification Settings
          </h1>
          <p style={{
            fontSize: '18px',
            color: theme.colors.textSecondary,
          }}>
            Customize how and when you receive notifications
          </p>
        </div>

        {/* Email Notifications */}
        <Card style={{ marginBottom: '24px' }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '500',
            color: theme.colors.textPrimary,
            marginBottom: '8px',
          }}>
            Email Notifications
          </h3>
          <p style={{
            fontSize: '14px',
            color: theme.colors.textSecondary,
            marginBottom: '20px',
          }}>
            Choose when to receive email notifications for each type of activity
          </p>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}>
            <Select
              label="Query Responses"
              value={emailQueryResponse}
              onChange={(e) => setEmailQueryResponse(e.target.value)}
              options={[
                { value: 'instant', label: 'Instant - Send immediately' },
                { value: 'daily', label: 'Daily Digest - Once per day' },
                { value: 'weekly', label: 'Weekly Digest - Once per week' },
                { value: 'never', label: 'Never - No emails' },
              ]}
            />

            <Select
              label="Beta Reader Applications"
              value={emailBetaApplication}
              onChange={(e) => setEmailBetaApplication(e.target.value)}
              options={[
                { value: 'instant', label: 'Instant - Send immediately' },
                { value: 'daily', label: 'Daily Digest - Once per day' },
                { value: 'weekly', label: 'Weekly Digest - Once per week' },
                { value: 'never', label: 'Never - No emails' },
              ]}
            />

            <Select
              label="Manuscript Requests"
              value={emailManuscriptRequest}
              onChange={(e) => setEmailManuscriptRequest(e.target.value)}
              options={[
                { value: 'instant', label: 'Instant - Send immediately' },
                { value: 'daily', label: 'Daily Digest - Once per day' },
                { value: 'weekly', label: 'Weekly Digest - Once per week' },
                { value: 'never', label: 'Never - No emails' },
              ]}
            />

            <Select
              label="Feedback Received"
              value={emailFeedback}
              onChange={(e) => setEmailFeedback(e.target.value)}
              options={[
                { value: 'instant', label: 'Instant - Send immediately' },
                { value: 'daily', label: 'Daily Digest - Once per day' },
                { value: 'weekly', label: 'Weekly Digest - Once per week' },
                { value: 'never', label: 'Never - No emails' },
              ]}
            />

            <Select
              label="New Messages"
              value={emailMessages}
              onChange={(e) => setEmailMessages(e.target.value)}
              options={[
                { value: 'instant', label: 'Instant - Send immediately' },
                { value: 'daily', label: 'Daily Digest - Once per day' },
                { value: 'weekly', label: 'Weekly Digest - Once per week' },
                { value: 'never', label: 'Never - No emails' },
              ]}
            />

            <Select
              label="System Notifications"
              value={emailSystem}
              onChange={(e) => setEmailSystem(e.target.value)}
              options={[
                { value: 'instant', label: 'Instant - Send immediately' },
                { value: 'daily', label: 'Daily Digest - Once per day' },
                { value: 'weekly', label: 'Weekly Digest - Once per week' },
                { value: 'never', label: 'Never - No emails' },
              ]}
            />
          </div>
        </Card>

        {/* In-App Notifications */}
        <Card style={{ marginBottom: '24px' }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '500',
            color: theme.colors.textPrimary,
            marginBottom: '8px',
          }}>
            In-App Notifications
          </h3>
          <p style={{
            fontSize: '14px',
            color: theme.colors.textSecondary,
            marginBottom: '20px',
          }}>
            Control which notifications appear in your notification center
          </p>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}>
            {[
              { label: 'Query Responses', value: inAppQueryResponse, setter: setInAppQueryResponse },
              { label: 'Beta Reader Applications', value: inAppBetaApplication, setter: setInAppBetaApplication },
              { label: 'Manuscript Requests', value: inAppManuscriptRequest, setter: setInAppManuscriptRequest },
              { label: 'Feedback Received', value: inAppFeedback, setter: setInAppFeedback },
              { label: 'New Messages', value: inAppMessages, setter: setInAppMessages },
              { label: 'System Notifications', value: inAppSystem, setter: setInAppSystem },
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px',
                  backgroundColor: theme.colors.backgroundAlt,
                  borderRadius: theme.borderRadius.medium,
                }}
              >
                <div style={{
                  fontSize: '15px',
                  color: theme.colors.textPrimary,
                  fontWeight: '500',
                }}>
                  {item.label}
                </div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}>
                  <input
                    type="checkbox"
                    checked={item.value}
                    onChange={(e) => item.setter(e.target.checked)}
                    style={{
                      width: '20px',
                      height: '20px',
                      cursor: 'pointer',
                    }}
                  />
                  <span style={{
                    marginLeft: '8px',
                    fontSize: '14px',
                    color: theme.colors.textSecondary,
                  }}>
                    {item.value ? 'Enabled' : 'Disabled'}
                  </span>
                </label>
              </div>
            ))}
          </div>
        </Card>

        {/* Digest Settings */}
        <Card style={{ marginBottom: '24px' }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '500',
            color: theme.colors.textPrimary,
            marginBottom: '8px',
          }}>
            Email Digest
          </h3>
          <p style={{
            fontSize: '14px',
            color: theme.colors.textSecondary,
            marginBottom: '20px',
          }}>
            Receive a summary of your notifications in a single email
          </p>

          <Select
            label="Enable Email Digest"
            value={enableDigest}
            onChange={(e) => setEnableDigest(e.target.value)}
            options={[
              { value: 'yes', label: 'Yes - Enable digest emails' },
              { value: 'no', label: 'No - Disable digest emails' },
            ]}
            style={{ marginBottom: '16px' }}
          />

          {enableDigest === 'yes' && (
            <>
              <Select
                label="Digest Frequency"
                value={digestFrequency}
                onChange={(e) => setDigestFrequency(e.target.value)}
                options={[
                  { value: 'daily', label: 'Daily - Once per day' },
                  { value: 'weekly', label: 'Weekly - Once per week (Monday)' },
                  { value: 'biweekly', label: 'Bi-Weekly - Every 2 weeks' },
                  { value: 'monthly', label: 'Monthly - Once per month' },
                ]}
                style={{ marginBottom: '16px' }}
              />

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: theme.colors.textPrimary,
                  marginBottom: '8px',
                }}>
                  Preferred Time (24-hour format)
                </label>
                <input
                  type="time"
                  value={digestTime}
                  onChange={(e) => setDigestTime(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: `1px solid ${theme.colors.border}`,
                    borderRadius: theme.borderRadius.medium,
                    fontSize: '15px',
                    fontFamily: theme.fonts.primary,
                  }}
                />
                <div style={{
                  marginTop: '6px',
                  fontSize: '13px',
                  color: theme.colors.textSecondary,
                }}>
                  {digestFrequency === 'daily' && 'Digest will be sent daily at this time'}
                  {digestFrequency === 'weekly' && 'Digest will be sent every Monday at this time'}
                  {digestFrequency === 'biweekly' && 'Digest will be sent every other Monday at this time'}
                  {digestFrequency === 'monthly' && 'Digest will be sent on the 1st of each month at this time'}
                </div>
              </div>
            </>
          )}
        </Card>

        {/* General Settings */}
        <Card style={{ marginBottom: '24px' }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '500',
            color: theme.colors.textPrimary,
            marginBottom: '8px',
          }}>
            General Settings
          </h3>
          <p style={{
            fontSize: '14px',
            color: theme.colors.textSecondary,
            marginBottom: '20px',
          }}>
            Configure additional notification preferences
          </p>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}>
            <Select
              label="Notification Sounds"
              value={soundEnabled}
              onChange={(e) => setSoundEnabled(e.target.value)}
              options={[
                { value: 'yes', label: 'Enabled - Play sound for new notifications' },
                { value: 'no', label: 'Disabled - Silent notifications' },
              ]}
              helperText="Play a sound when you receive a new notification"
            />

            <Select
              label="Desktop Notifications"
              value={desktopNotifications}
              onChange={(e) => setDesktopNotifications(e.target.value)}
              options={[
                { value: 'yes', label: 'Enabled - Show desktop notifications' },
                { value: 'no', label: 'Disabled - No desktop notifications' },
              ]}
              helperText="Show browser notifications even when tab is not active"
            />

            <Select
              label="Notification Badge"
              value={notificationBadge}
              onChange={(e) => setNotificationBadge(e.target.value)}
              options={[
                { value: 'yes', label: 'Enabled - Show unread count' },
                { value: 'no', label: 'Disabled - Hide unread count' },
              ]}
              helperText="Display unread notification count in the header"
            />
          </div>
        </Card>

        {/* Info Box */}
        <Card style={{
          marginBottom: '32px',
          backgroundColor: theme.colors.primaryLight,
          border: `1px solid ${theme.colors.primary}`,
        }}>
          <div style={{
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-start',
          }}>
            <div style={{ fontSize: '20px' }}>ℹ️</div>
            <div>
              <div style={{
                fontSize: '16px',
                fontWeight: '500',
                color: theme.colors.textPrimary,
                marginBottom: '8px',
              }}>
                About Notification Settings
              </div>
              <ul style={{
                fontSize: '14px',
                color: theme.colors.textSecondary,
                margin: 0,
                paddingLeft: '20px',
                lineHeight: '1.6',
              }}>
                <li>Changes to email settings may take up to 10 minutes to take effect</li>
                <li>Digest emails include a summary of all activity since the last digest</li>
                <li>Important security notifications cannot be disabled</li>
                <li>Desktop notifications require browser permission</li>
              </ul>
            </div>
          </div>
        </Card>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '16px',
        }}>
          <div style={{ display: 'flex', gap: '12px' }}>
            <Button
              variant="ghost"
              onClick={() => window.location.href = '/notifications'}
            >
              ← Back to Notifications
            </Button>
            <Button
              variant="outline"
              onClick={handleTestNotification}
            >
              Send Test Notification
            </Button>
          </div>
          <Button onClick={handleSave}>
            Save Settings
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};
